// В.2.h / В.2.h-rebalance: ИИ-Проект «Бессмертный» — активка «Уничтожь
// своего юнита → добавь его current_hp к ХП Героя (cap по max_hp)».
//
// Picker: свой юнит (не Герой). Если своих нет — активка не срабатывает.
//
// Эффект:
//   1) Snapshot current_hp выбранного юнита (ДО destroyUnit).
//   2) destroyUnit(target) — полная смерть, on_unit_died-триггеры
//      (включая новую пассивку Бессмертного: +base.hp погибшего к Герою).
//   3) healUnit(bessmertnyy_hero, snapshot_current_hp). Cap по max_hp
//      Героя гарантирует healUnit (не выше base.hp).
//
// В.2.h-rebalance: маркер fromBessmertnyActive больше не нужен — старый
// healBlocker удалён, любой хил Героя проходит обычно.

import { destroyUnit } from './destroy.js';
import { healUnit } from './heal.js';
import { HERO_ID } from './bessmertnyy.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

registerImplementedAbility(HERO_ID, 'active');

const LABEL = 'Бессмертный (active)';
const SOURCE_ID = 'liv_ii_proekt_bessmertnyy_active';

export { HERO_ID };

export function getBessmertnyyActiveTargets(state, playerIdx) {
  const me = state?.players?.[playerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u => u.type === 'unit' && u.isAlive());
}

export function bessmertnyyActiveAvailable(state, playerIdx) {
  const p = state?.players?.[playerIdx];
  if (!p || p.hero?.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  if (getBessmertnyyActiveTargets(state, playerIdx).length === 0) return false;
  return true;
}

export function bessmertnyyActive(state, playerIdx, targetInstanceId = null) {
  if (!bessmertnyyActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  const me = state.players[playerIdx];
  const candidates = getBessmertnyyActiveTargets(state, playerIdx);
  let target = null;
  if (targetInstanceId != null) {
    target = candidates.find(u => u.instanceId === targetInstanceId) || null;
  }
  if (!target) target = candidates[state.rng.int(candidates.length)];
  if (!target) return { ok: false, reason: 'no_target' };
  const snapshot = target.current?.hp ?? 0;
  state.log?.add(
    `💀 ${LABEL} [${me.name}]: жертва ${target.name_ru} (HP ${snapshot}) → +${snapshot} ХП Герою (cap по max)`
  );
  destroyUnit(state, target, playerIdx, /*killer=*/ me.hero, /*killerIdx=*/ playerIdx);
  // healBlocker удалён в В.2.h-rebalance — любой хил Героя проходит обычно.
  healUnit(state, me.hero, snapshot, {
    id: SOURCE_ID, name_ru: LABEL, type: 'action'
  });
  me.heroActiveUsed = true;
  return { ok: true, target, healed: snapshot };
}
